var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content)?_c('StoryblokComponent',{attrs:{"blok":_vm.content,"component":"Page"}}):_c('SkeletonLoader',{staticClass:"w-full h-[80px] sm:h-[300px]",attrs:{"is-loading":!_vm.content,"height":"300","margin":"0.25rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }